var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    { staticClass: "row roomy margin-bottom-4xl", style: _vm.componentStyle },
    [
      _c(
        "div",
        {
          staticClass:
            "column-12 tablet:column-8 laptop:column-12 margin-bottom-lg",
        },
        [
          _c(
            "div",
            { staticClass: "display-flex" },
            [
              _c("font-awesome-icon", {
                attrs: {
                  icon: _vm.$v6[_vm.iconStyle][_vm.iconName],
                  "fixed-width": "",
                  size: _vm.iconSize,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "margin-left-2xl" },
                [
                  _vm._t("title", function () {
                    return [
                      _c("h2", { staticClass: "h4" }, [
                        _vm._v(_vm._s(_vm.title)),
                      ]),
                    ]
                  }),
                  _vm._v(" "),
                  _vm._t("default"),
                ],
                2
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "column-12 tablet:column-4 tablet:text-right laptop:column-12 laptop:text-left padding-left-5xl",
        },
        [
          _vm._t("action-primary"),
          _vm._v(" "),
          _vm.hasSecondaryAction
            ? _c(
                "span",
                {
                  staticClass:
                    "display-inline-block tablet:display-block tablet:margin-top-lg laptop:display-inline-block laptop:margin-top-0 padding-x-lg",
                },
                [_vm._t("action-secondary")],
                2
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }